import React from "react";

const SpecificViewModal = ({ show, onHide, data }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-lg w-full">
        <div className="flex justify-between items-center border-b p-4">
          <h2 className="text-lg font-semibold">Detail Answer</h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-2xl"
            onClick={onHide}
          >
            &times;
          </button>
        </div>
        <div className="p-4">
          <div
            
            dangerouslySetInnerHTML={{ __html: data?.Answer || "No answer available." }}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecificViewModal;
